import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(theme => ({
	grayBox: {
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[50]),
		boxShadow: "none",
		padding: theme.spacing(1.5),
		minHeight: "44px"
	},
	dividerSummary: {
		fontWeight: "bold",
		textTransform: "uppercase"
	}
}))

export default useStyles
